import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetResourceTags = () => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.ResourceTags], () => api.base
        .get(`${config.appUrls.api}/api/Resource/Tags`)
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
